import React, {Component} from 'react';
import Portal from 'react-portal';
import Select from 'react-select';
import {Editor, EditorState, ContentState, convertToRaw, RichUtils} from 'draft-js';

import DraftControllButton from './DraftControllButton';
import TopTools from './TopTools';
import BottomTools from './BottomTools';



import './styles/styles.scss';

function getCurrentStyles(editorState) {
    const selection = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    const characterList = block.getCharacterList();

    characterList.forEach(elList => {
        elList.getStyle()
    });
}

const RichUtilsComponent = (props)=> {
    const handleClick = (e)=> {
        e.stopPropagation();
    };
    const positioned = props.visible ? {
        top: 0,
        left: 0,
        right: 0,
    } : {
        display: 'none',
    };

    let inactive = false;

    const {editorState} = props;
    const selection = editorState.getSelection();

    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    const blockType = block.getType();
    const fontOptions = props.fontSizeHandler.getStylesForBlockType(blockType);
    let currentValue = !fontOptions.options ? false : fontOptions.default;

    if (currentValue !== false) {
        editorState.getCurrentInlineStyle().forEach(el => {
            return fontOptions.options.map(option => {
                if (option.value === el) {
                    currentValue = el;
                }
            });
        });
    }

    const characterList = block.getCharacterList();
    // characterList.forEach(el => {
    //     let value = true;
    //     return fontOptions.filter(option => {
    //         if(el.hasStyle(option.value)) {
    //             console.log('has value');
    //             return false;
    //         }
    //     })
    // });

    const renderSelect = ()=> {
        if (currentValue !== false) {

            const options = fontOptions.options.map(singleValue => {
                return {
                ...singleValue,
                    label: singleValue.option
                }
            });

            console.log(options);

            return (
            <Select
                name="draft-fonts"
                value={currentValue}
                options={options}
                disabled={inactive}
                onChange={(option) => props.onToggleSize(option.value)}
                clearable={false}
                searchable={false}
            />
            )

            return (
            <select onChange={(e) => props.onToggleSize(e.target.value)} value={currentValue}>
                {fontOptions.options.map((font, index) => {
                    return (
                    <option key={index} value={font.value}>{font.option}</option>
                    )
                })}
            </select>
            )
        }
        return null;
    };

    return (
    <Portal isOpened={true}>
        <div className="richutils" style={positioned} onClick={handleClick}>
            <div className="richutils__wrapper">
                <DraftControllButton type="undo"
                                     label="Undo"
                                     inactive={props.editorState.getUndoStack().isEmpty()}
                                     editorState={props.editorState} onClick={props.onUndo}
                />
                <DraftControllButton type="redo"
                                     label="Redo"
                                     inactive={props.editorState.getRedoStack().isEmpty()}
                                     editorState={props.editorState}
                                     onClick={props.onRedo}
                />
                <div className="richutils__tools">
                    {renderSelect()}
                    <TopTools onToggle={props.onToggle}
                              editorState={props.editorState}
                              onToggleBlock={props.onToggleBlock}
                    />
                    <BottomTools editorState={props.editorState}
                                 onToggleBlock={props.onToggleBlock}
                                 onAlignmentChange={props.onAlignmentChange}
                    />
                </div>
            </div>
        </div>
    </Portal>
    )
};

export default RichUtilsComponent;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/RichUtilsComponent.js